/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum IndependentToken {
    TOKEN_0 = 'TOKEN_0',
    TOKEN_1 = 'TOKEN_1',
}
